import { Button, Modal } from 'antd';
import { useNavigate } from 'react-router-dom';

import owlImg from '../../../../assets/img/pet/corujaFeliz.png';

import { ContainerFooter, Content, ModalContainer } from './styles';

interface InviteProps {
  id: number;
  liga: {
    id: number;
    nome: string;
    privada: boolean;
  };
}

interface SuccessEnterLeagueModalProps {
  isOpen: boolean;
  invite: InviteProps;
}

export const SuccessEnterLeagueModal = ({
  isOpen,
  invite,
}: SuccessEnterLeagueModalProps) => {
  const navigate = useNavigate();

  const handleCloseModal = () => {
    navigate('/leagues');
  };
  return (
    <ModalContainer>
      <Modal
        visible={isOpen}
        onCancel={handleCloseModal}
        bodyStyle={{ padding: 0 }}
        footer={[
          <ContainerFooter key="footer">
            <Button
              type="primary"
              onClick={handleCloseModal}
              key="handleCloseModal"
            >
              Fechar
            </Button>
          </ContainerFooter>,
        ]}
      >
        <Content>
          <h1>Sucesso!</h1>

          <img src={owlImg} alt="Imagem de uma coruja" />

          <span>
            <p>
              Você entrou para liga
              <strong>{invite.liga && ` ${invite.liga.nome}.`}</strong>
            </p>
          </span>
        </Content>
      </Modal>
    </ModalContainer>
  );
};
